import { render, staticRenderFns } from "./ChangePasswordUserController.html?vue&type=template&id=e8a3314a&scoped=true&"
import script from "./ChangePasswordUserController.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordUserController.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordUserController.scss?vue&type=style&index=0&id=e8a3314a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a3314a",
  null
  
)

export default component.exports